export function phoneMask(value: string): string {
  if (!value) return '';

  const digits = value.replace(/\D/g, '');

  return digits.length === 11
    ? digits.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3')
    : digits.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
}
